import { render } from "./C4CaseInfo.vue?vue&type=template&id=0d185b7c"
import script from "./C4CaseInfo.vue?vue&type=script&lang=js"
export * from "./C4CaseInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__